import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Summary = ({summaryData}) => {
   


  const handleBackbutton=()=>{

    setTimeout(function() {
        location.reload();
    }, 500);

  }

  return (
    <>
    <div className="formbold-main-wrapper add-plan-wrapper">
      <div className="formbold-form-wrapper add-plan-form pos-rel">

          <div className="container mt-5">
            <div className="text-center">
              <div style={{fontFamily:'-moz-initial'}}>
                <h2
                  className="fw-bold mb-3"
                  style={{ fontSize: "24px", color: "#344567" }}
                >
                  Thank you. Recharge Vouchers Queued successfully completed.
                </h2>
                <h5 className="text-muted mb-4">Queued Voucher Details</h5>
                <p className="mt-3" style={{color:'#000'}}>
                  <strong>Reference Number:</strong>{" "}
                  <span className="text-muted">
                    {summaryData?.reference_id}
                  </span>
                  <br />
                  <strong>Date:</strong>{" "}
                  <span className="text-muted">
                    {summaryData?.date}
                  </span>
                  <br />
                  <strong>Total:</strong>{" "}
                  <span className="text-muted">
                    ${summaryData?.total_amount}
                  </span>
                  <br />
                  <strong>Payment Method:</strong>{" "}
                  <span className="text-muted">
                    {summaryData?.payment_method}
                  </span>
                  <br />
                  <strong>Mobile Number:</strong>{" "}
                  <span className="text-muted">
                    {summaryData?.mobile_number}
                  </span>
                </p>

                <div className="oc-table mt-4">
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead className="thead-light bg-light">
                        <tr>
                          <th className="text-left" style={{ color: "#344567" }}>
                            Voucher Code
                          </th>
                          <th className="text-center" style={{ color: "#344567" }}>
                            Plan Name
                          </th>
                          <th className="text-center" style={{ color: "#344567" }}>
                            Recharge Date
                          </th>
                          <th className="text-center" style={{ color: "#344567" }}>
                            Amount
                          </th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        {summaryData?.Vouchers.map((data, index) => (
                          <tr key={index}>
                            <td>{data?.voucher_code}</td>
                            <td className="text-center">{data?.offerName}</td>
                            <td className="text-center">{data?.expiry_date}</td>
                            <td className="text-center">${data?.amount}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="row mt-5">
                  {/* Address Details */}
                  <div className="col-lg-6">
                    <div className="bg-light p-4 rounded shadow-sm">
                      <h6
                        className="fw-bold mb-3"
                        style={{ color: "#344567", fontSize: "18px" }}
                      >
                        Address Details
                      </h6>
                      <p className="mb-1">
                        {summaryData?.company}
                      </p>
                      <p>{summaryData?.address}</p>
                      <p className="text-muted small mt-3" style={{fontSize:"12px"}}>
                        <span className="text-danger">*</span> If the address details
                        are incorrect, please contact Telsim Retailer Support to change
                        the delivery address before confirming the order.
                      </p>
                    </div>
                  </div>

                  {/* Summary Details */}
                  <div className="col-lg-6 ">
                    <div className="bg-light p-4 rounded shadow-sm text-end summary-details-purchase">
                      <p style={{color:'#344567'}} className="mb-2">
                        <strong>Subtotal:</strong>{" "}
                        <span className="text-muted">
                          ${summaryData?.sub_total}
                        </span>
                      </p>
                      <p style={{color:'#344567'}} className="mb-2">
                        <strong>Discount Applied:</strong>{" "}
                        <span className="text-muted">
                          ${summaryData?.discount_applied}
                        </span>
                      </p>
                      <p style={{color:'#344567'}} className="mb-2">
                        <strong>Wallet Amount Used:</strong>{" "}
                        <span className="text-muted">
                          ${summaryData?.wallet_used}
                        </span>
                      </p>
                      <p style={{color:'#344567'}} className="mb-3">
                        <strong>Grand Total:</strong>{" "}
                        <span className="text-muted">
                          ${summaryData?.grand_total}
                        </span>
                      </p>

                      {/* Total Section */}
                      <div
                        className="d-flex justify-content-end align-items-center"
                        style={{
                          gap: "10px",
                          fontSize: "18px",
                          fontWeight: "bold",
                          color: "#344567",
                        }}
                      >
                        <span>Total:</span>
                        <span
                          className="text-muted"
                          style={{
                            fontSize: "16px",
                            fontWeight: "normal",
                          }}
                        >
                          ${summaryData?.total_amount}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <br/>
                <br/>
                

                <div className="button-container">
                      <button onClick={handleBackbutton}>
                        Back
                      </button>
                </div>

              </div>
            </div>
          </div>

    </div>
    </div>
  </>
  );
};

export default Summary;
